export default __webpack_public_path__ + "static/media/logo-link.a6755b9e.svg";